import { useEffect, useState } from 'react';
import { Warning } from './Warning';
import { logout, useApp, verifyPasscode } from '../store';
import { Loader } from './Loader';
import { useTranslation } from 'react-i18next';

export function VerifyPasscode() {
  const { t } = useTranslation();
  const { state, dispatch } = useApp();
  const [warning, setWarning] = useState<string[]>([]);
  const [passcode, setPasscode] = useState('');

  useEffect(() => {
    if (state.passcodeRetries === 0) {
      setWarning([]);
      logout(dispatch);
    }

    if (state.passcodeRetries) {
      if (state.selfRegisterOpen) {
        setWarning([t('warningBadPasscode')]);
      } else {
        setWarning([t('warningNoSuchUser')]);
      }
    }

    setPasscode('');
  }, [state.passcodeRetries, dispatch, t, state.selfRegisterOpen]);

  const handlePasscode = () => {
    if (passcode === '') {
      setWarning([t('warningPasscodeRequired')]);
    } else {
      verifyPasscode( passcode , dispatch);
    }
  };

  const handleLogout = () => {
    logout(dispatch);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handlePasscode();
    }
  };

  if (state.hasVerifiedPasscode || !state.isLoggedIn) {
    return null;
  }

  if (state.loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="logout_menu">
        <button className="logout" onClick={handleLogout}>
          &#10005;
        </button>
      </div>
      <Warning message={warning} />
      <p>{t('passcodeText')}</p>

      <input
        type="password"
        className={'passcode'}
        placeholder={t('passcodeInput')}
        value={passcode}
        id={'password'}
        onChange={(e) => {
          setPasscode(e.target.value);
          setWarning([]);
        }}
        onKeyDown={handleKeyDown}
      />

      <button className="primary" onClick={() => handlePasscode()}>
        {t('passcodeButton')}
      </button>
    </>
  );
}
